import { inject, observer } from 'mobx-react'
import { FC, useEffect } from 'react'
import { useApolloClient } from '@apollo/react-hooks'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Search as SearchStore } from '../stores/search'
import { Prospects as ProspectsStore } from '../stores/prospects'

interface Props extends RouteComponentProps {
  search?: SearchStore
  prospects?: ProspectsStore
}

const ProspectGetter: FC<Props> = ({ search }) => {
  const client = useApolloClient()
  useEffect(() => {
    // Removed User profile as it was causing issue for multiple api calls, did not found any use of that here.
    search?.getProspectsFromGraph(client)
  }, [search?.nextToken])
  return null
}

export default inject('prospects', 'search')(withRouter(observer(ProspectGetter)))
